<template>
  <div id="docviewer" class="docviewer" v-loading.body="loading">
    <span v-html="rawHtml"></span>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import layout from '../../api/helpers/layout'

  export default {
    name: 'docviewer',
    props: ['doctype', 'uid'],
    data() {
      return {
        loading: false,
        rawHtml: ''
      }
    },
    methods: {
      fetch(doctype) {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          ///DOC
          if(doctype) {
            let url = '';
            if(doctype === '0')
              url = `${prefix}resume/questionnaire`;
            if(doctype === '1' && this.uid)
              url = `${prefix}vacancycandidate/${this.uid}/application`;
            if(url) {
              self.$http.get(url, options)
                .then(response => {
                  self.rawHtml = response.data;
                  self.loading = false;
                  setTimeout(window.print, 1000);
                })
                .catch(data => {
                  self.$gf.checkError(data);
                  self.loading = false;
                });
            }
          }
          self.loading = false;
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);
      let path = this.$route.path;
      if(path && path.includes('docviewer'))
        Event.$emit('onDocIsShown');
    },
    created() {
      window.addEventListener('resize', this.resize);
      this.fetch(this.doctype);
    },
    beforeRouteEnter: function (to, from, next) {
      Event.$emit('onDocIsShown');
      next();
    },
    beforeRouteLeave: function (to, from, next) {
      Event.$emit('onDocIsClosed');
      next();
    }
  }
</script>

<style scoped>
  .docviewer {
    --height: calc(100% - 20px);
    --border: 1px solid #d1dbe5;
    --padding: 10px;
    --overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/personalarea/docviewer.vue